<template>
    <div class="container form-container p-4">
        <div class="text-3xl mb-4 pb-2 font-light flex items-end justify-between">
            <div data-cy="admin-settings-audit-logs-title">
                {{ $t('company.audit_logs.title') }}
            </div>
        </div>
        <audit-log-table :is_admin_section="true" ref="AuditLogsTable"></audit-log-table>
    </div>
</template>

<script>
import AuditLogTable from '@/components/tables/AuditLogs.vue';

export default {
    components: {
        AuditLogTable,
    },
    methods: {
        reload() {
            this.$refs.AuditLogsTable.reload();
        },
    },
};
</script>
